/* ============================================================
   HIT: alturas medidas.
   Mesmo contrato da v6, agora medindo o chrome da B (direcao-b/index.html, atualizaChrome()). O CSS lê variáveis que só o navegador sabe:
   --h-topo   altura do cabeçalho (#cab, sem a faixa âmbar): o que grudar embaixo dele usa este valor;
   --h-baixo  altura da barra fixa de baixo que estiver visível (#nav-m ou a barra de compra #compra): o corpo reserva
              esse espaço para o rodapé não ficar escondido atrás dela;
   --barh     altura da barra de compra do produto (#compra) quando ela aparece; sem ela vale o reserva padrão do CSS
              (--barh-padrao, 84px, o mesmo da B).
              O CSS da B (.pad-b, .wa, .toast em body.tem-barra) sobe por ela.
   --bar (56px, a barra de navegação) é constante e fica no CSS. Sem JS, o CSS tem um padrão para --h-topo, --h-baixo e --barh.
   ============================================================ */
(function () {
  'use strict';

  var raiz = document.documentElement;
  var cab = document.getElementById('cab');
  var nav = document.getElementById('nav-m');
  // #compra (barra de compra do produto) só existe quando a tarefa de produto a renderiza
  var compra = document.getElementById('compra');
  var barras = [nav, compra].filter(Boolean);

  // último valor gravado no :root: só escreve quando muda (setProperty reinicia o cálculo de estilo da página inteira)
  var ultimo = { topo: null, baixo: null, barh: null };

  function altura(el) {
    return Math.round(el.getBoundingClientRect().height) + 'px';
  }

  function visivel(el) {
    return getComputedStyle(el).display !== 'none';
  }

  function gravar(nome, chave, valor) {
    if (ultimo[chave] === valor) return;
    ultimo[chave] = valor;
    raiz.style.setProperty(nome, valor);
  }

  // lê tudo antes de gravar: gravar invalida o estilo, e uma leitura depois disso forçaria um novo cálculo de layout
  function medir() {
    var hCab = cab ? altura(cab) : null;
    var barra = barras.find(visivel);
    var hBaixo = barra ? altura(barra) : '0px';
    var hCompra = compra && visivel(compra) ? altura(compra) : null;

    if (hCab) gravar('--h-topo', 'topo', hCab);
    gravar('--h-baixo', 'baixo', hBaixo);
    // sem barra de compra, o reserva padrão do CSS (--barh-padrao: 84px, o mesmo da B)
    gravar('--barh', 'barh', hCompra || 'var(--barh-padrao)');
  }

  medir();
  if ('ResizeObserver' in window) {
    // o cabeçalho muda com o breakpoint (.nav-d aparece); as barras somem e voltam com ele e com body.tem-barra
    var observador = new ResizeObserver(medir);
    if (cab) observador.observe(cab);
    barras.forEach(function (el) { observador.observe(el); });
  } else {
    // sem ResizeObserver, só o resize da janela avisa (com ele, o observador já cobre isso)
    window.addEventListener('resize', medir);
  }
})();
